var map = {
	"./DrLubhani/ChangeColor": [
		803,
		188
	],
	"./Ganga/ChangeColor": [
		805,
		195
	],
	"./Indus/ChangeColor": [
		807,
		209
	],
	"./Kabini/ChangeColor": [
		809,
		217
	],
	"./Kaveri/ChangeColor": [
		717,
		22
	],
	"./Luni/ChangeColor": [
		811,
		224
	],
	"./Narmada/ChangeColor": [
		813,
		228
	],
	"./Nethravathi/ChangeColor": [
		815,
		236
	],
	"./Neyyar/ChangeColor": [
		817,
		241
	],
	"./Periyar/ChangeColor": [
		819,
		245
	],
	"./SAANVI/ChangeColor": [
		821,
		256
	],
	"./Sabarmathi/ChangeColor": [
		823,
		264
	],
	"./Sparsh/ChangeColor": [
		825,
		271
	],
	"./Sutlej/ChangeColor": [
		827,
		276
	],
	"./Yamuna/ChangeColor": [
		829,
		283
	],
	"./pamba/ChangeColor": [
		831,
		293
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2081;
module.exports = webpackAsyncContext;